import cn from 'classnames'
import { memo, useCallback } from 'react'
import { shallowEqual } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import { ILinkProps } from './models'
import { linkTranslation } from './translation'

import styles from './Link.module.scss'

export const Link = memo<ILinkProps>(({ isDisabled, isFile, link, text, className, onDelete }) => {
  const renderTip = useCallback(() => <Translation text={linkTranslation.delete} span />, [])
  return (
    <div className={cn(styles.link, className)} key={link}>
      <a
        className={styles.linkValue}
        download={isFile && text}
        href={link}
        rel="noreferrer"
        target="_blank"
      >
        {text}
      </a>
      <Tooltip tipContent={renderTip}>
        <Button
          className={styles.deleteLinkBtn}
          color="danger"
          variant="text"
          iconButton="kbase kbase-delete"
          onClick={onDelete}
          disabled={isDisabled}
        />
      </Tooltip>
    </div>
  )
}, shallowEqual)
